module.exports = __webpack_public_path__ + "static/img/diamond.be36838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/diamond.png
// module id = h38W
// module chunks = 2